<template>
  <div class="quick-filter-container">
    <div
      class="quick-filter-item"
      :class="{ 'hide-icon': hideIcon, active: nynow }"
      @click="toggleQuickFilter('nynow')"
    >
      <Icon v-if="!hideIcon" icon-key="booth" />
      <span class="b1">NY NOW</span>
    </div>
    <div
      class="quick-filter-item"
      :class="{ 'hide-icon': hideIcon, active: bulletin_picks }"
      @click="toggleBulletinPicks"
    >
      <Icon v-if="!hideIcon" icon-key="star" />
      <span class="b1">Bulletin Picks</span>
    </div>
    <div
      v-if="headerType === 'product'"
      class="quick-filter-item"
      :class="{ 'hide-icon': hideIcon, active: deals_and_promos }"
      @click="toggleQuickFilter('deals_and_promos')"
    >
      <Icon v-if="!hideIcon" icon-key="price-tag" />
      <span class="b1">Deals & Promos</span>
    </div>
    <div
      v-if="headerType === 'product'"
      class="quick-filter-item"
      :class="{ 'hide-icon': hideIcon, active: new_arrivals }"
      @click="toggleQuickFilter('new_arrivals')"
    >
      <Icon v-if="!hideIcon" icon-key="lighting" />
      <span class="b1">New Arrivals</span>
    </div>
  </div>
</template>

<script>
import { paramsHelper } from '@/components/mixin/paramsHelper'
import { filterHelper } from '@/components/shared/filters/filterTypes/filterHelper'
import { TradeShowApi } from '@/api'

export default {
  name: 'QuickFilters',
  mixins: [paramsHelper, filterHelper],
  props: {
    hideIcon: {
      type: Boolean,
      default: false
    },
    headerType: {
      type: String,
      default: 'product' // 'product', 'brand'
    }
  },
  data() {
    return {
      activeTradeShowId: null,
      nynow: false,
      bulletin_picks: false,
      deals_and_promos: false,
      new_arrivals: false
    }
  },
  watch: {
    $route(to) {
      this.bulletin_picks = to.query.bulletin_picks === true || localStorage.getItem('BULLETIN_PICKS')
      this.updateURLParams('bulletin_picks', this.bulletin_picks ?? null)
      this.nynow = !!to.query.active_trade_show_id
      this.deals_and_promos = to.query.deals_and_promos
      this.new_arrivals = to.query.new_arrivals
    }
  },
  async mounted() {
    await this.getEventID()
    this.bulletin_picks = this.$route.query.bulletin_picks === 'true' || localStorage.getItem('BULLETIN_PICKS')
    this.updateURLParams('bulletin_picks', this.bulletin_picks ?? null)
    this.nynow = !!this.$route.query.active_trade_show_id
    this.deals_and_promos = this.$route.query.deals_and_promos === 'true'
    this.new_arrivals = this.$route.query.new_arrivals === 'true'
  },

  methods: {
    toggleQuickFilter(key) {
      if (key === 'nynow') {
        this.updateURLParams(
          'active_trade_show_id',
          !this.$route.query.active_trade_show_id ? this.activeTradeShowId : null
        )
      } else {
        this[key] = !this[key]
        this.updateURLParams(key, this[key] ?? null)
      }

      if (this[key]) {
        this.trackEvent(key)
      }
    },
    toggleBulletinPicks() {
      this.bulletin_picks = !this.bulletin_picks
      if (!this.bulletin_picks) {
        localStorage.removeItem('BULLETIN_PICKS')
      } else {
        localStorage.setItem('BULLETIN_PICKS', this.bulletin_picks)
      }
      this.updateURLParams('bulletin_picks', this.bulletin_picks ?? null)
      if (this.bulletin_picks) {
        this.trackEvent('Bulletin Picks')
      }
    },
    async getEventID() {
      const data = await TradeShowApi.getActiveTradeShows()
      this.activeTradeShowId = data[0].a2z_event_id
    },
    trackEvent(filterType) {
      this.$trackEvent({
        action: 'Quick Filter Used',
        properties: {
          'Quick Filter Type': filterKeyMap[filterType] || filterType,
          'From page': this.getCurrentPage()
        }
      })
    },
    getCurrentPage() {
      const routeName = this.$route.name
      const { navItemName, navItemParentName } = this.$route.params
      switch (routeName) {
        case 'productsFromNavigation':
          if (navItemName && navItemParentName) {
            return 'Subcategory Page'
          }
          return 'Category Page'
        case 'brands':
          return 'Brand directory'
        case 'search':
          return 'Search results'
        case 'Collection':
          return 'Collection'
        default:
          return 'Unknown Page'
      }
    }
  }
}

const filterKeyMap = {
  nynow: 'NY NOW',
  deals_and_promos: 'Deals & Promos',
  new_arrivals: 'New Arrivals'
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/base/_vars.scss';
@import '@/assets/sass/base/mixins.scss';
.quick-filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  @include respond-to('medium') {
    overflow-x: scroll;
    flex-wrap: nowrap;
  }
}
.quick-filter-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid $color-grey-3;
  padding: 8px 24px 8px 16px;
  border-radius: 100px;

  > span {
    white-space: nowrap;
  }

  @include respond-to('medium') {
    padding: 8px 16px;
  }

  @include respond-to('medium') {
    > i {
      display: none;
    }
  }

  &.hide-icon {
    padding: 8px 16px;
  }

  &.active {
    background-color: $color-green;
    border-color: $color-green;
  }

  &:hover {
    border-color: $color-black;
  }
}
</style>
